export const DEPRECIATION_LOADING = "DEPRECIATION_LOADING";
export const DEPRECIATION_RESET = "DEPRECIATION_RESET";
export const GET_DEPRECIATION = "GET_DEPRECIATION";
export const GET_DEPRECIATION_SUCCESS = "GET_DEPRECIATION_SUCCESS";
export const GET_DEPRECIATION_FAIL = "GET_DEPRECIATION_FAIL";
export const DELETE_DEPRECIATION = "DELETE_DEPRECIATION"
export const DELETE_DEPRECIATION_SUCCESS = "DELETE_DEPRECIATION_SUCCESS"
export const DELETE_DEPRECIATION_FAIL = "DELETE_DEPRECIATION_FAIL"
export const UPDATE_DEPRECIATION = "UPDATE_DEPRECIATION"
export const UPDATE_DEPRECIATION_SUCCESS = "UPDATE_DEPRECIATION_SUCCESS"
export const UPDATE_DEPRECIATION_FAIL = "UPDATE_DEPRECIATION_FAIL"
export const ADD_NEW_DEPRECIATION = "ADD_NEW_DEPRECIATION"
export const ADD_DEPRECIATION_SUCCESS = "ADD_DEPRECIATION_SUCCESS"
export const ADD_DEPRECIATION_FAIL = "ADD_DEPRECIATION_FAIL"
export const DEPRECIATION_RESET_CREATE = "DEPRECIATION_RESET_CREATE"